import { rest } from "msw";
import { uuid } from "@odm/utils/utils";

export const handlers = [
  rest.post("/files/:type/upload", (req, res, ctx) => {
    const id = uuid().replaceAll("-", "");
    const type = req.params.type;
    const fileName = req.body.file.name;
    const fileInfo = {
      id: req.id,
      type: type,
      url: `http://localhost:3030/files/${type}/${id}/${fileName}`,
      fileName: fileName,
      fileSize: req.body.file.size,
      mediaType: req.body.file.type,
      modifiedAt: req.body.file.lastModified,
      etag: "0x1EDD6408B77C160",
      metadata: {},
    }
    const uploadDelay = Math.trunc(Math.random() * 10000);
    return res(
      ctx.delay(uploadDelay),
      ctx.json(fileInfo)
    );
  }),

  rest.post("/files/:type/:id", (req, res, ctx) => {
    return res(
      ctx.json({
        id: "13a3323d-494a-4386-8d50-4e2e61f610ed",
        type: "withdrawal-applications",
        url:
          "http://localhost:8087/files/withdrawal-applications/13a3323d-494a-4386-8d50-4e2e61f610ed/new (1).pdf",
        fileName: "new (1).pdf",
        fileSize: 88207,
        mediaType: "application/pdf",
        modifiedAt: "2021-03-04T14:02:53Z",
        etag: "0x19BF6605E564A50",
      })
    );
  }),

  rest.delete("/files/:type/:id", (req, res, ctx) => {
    return res(
      ctx.json({
        success: true,
      })
    );
  }),
];
